import { isValidPhoneNumber } from 'react-phone-number-input/max';

export const validatePhone = (value: string, required = false) => {
  if (!value) {
    return required ? 'Phone number is required' : '';
  }
  return isValidPhoneNumber(value) ? '' : 'Invalid phone number for the selected country';
};
